import Vue from 'vue';

Vue.filter('stringToDate', (value: string) => {
  if (!value) {
    return '<n/a>';
  }
  const date = new Date(value);

  return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()} - `
    + `${date.getHours()}:${date.getMinutes() < 10 ? '0' : ''}${date.getMinutes()}`;
});
